import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const SipComponent = lazy(() =>
  import("@/modules/insights/pages/sip").then((module) => ({
    default: module.SipTab,
  }))
);

export const Route = createFileRoute("/(auth)/_headed/insights/_layout/sip")({
  component: SipComponent,
});
